import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function() {
    const response = await api.fetch(`/api/v2/airbnb/listings`)
    return await handleResponse(response)
  }
}
